import React from "react";
import * as ReactDOM from "react-dom";
import styled from "styled-components";
import mediaQueries from "~/guidelines/Theme/mediaQueries";

type StickyContainerProps = {
  $isVisible?: boolean;
  $isAlwaysVisible?: boolean;
  children: React.ReactNode;
};

const StickyContainer = styled.div.attrs((props: StickyContainerProps) => ({
  $isVisible: props.$isVisible ?? true,
  $isAlwaysVisible: props.$isAlwaysVisible ?? false,
}))<StickyBarProps>`
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  transform: ${({ $isVisible }) =>
    $isVisible ? "translate(0)" : "translate(0, calc(100vh))"};
  transition: transform 0.5s ease-in-out;

  ${mediaQueries.lg()} {
    ${({ $isAlwaysVisible }) => ($isAlwaysVisible ? "" : "display: none;")};
  }
`;

const TopStickyContainer = styled(StickyContainer)`
  position: fixed;
  left: 0;
  top: 0;
  padding-top: env(safe-area-inset-top, 0);
  background-color: ${({ theme }) => theme.color.background.lightSecond};
  border-bottom: 1px solid ${({ theme }) => theme.color.line.lightFirst};
`;

const BottomStickyContainer = styled(StickyContainer)`
  position: fixed;
  z-index: 1000;
  left: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.color.background.lightFirst};
  box-shadow: ${({ theme }) => theme.shadow.navigation};
`;

type StickyBarProps = {
  isVisible?: boolean;
  isAlwaysVisible?: boolean;
  children: React.ReactNode;
};

export const BottomStickyBar = ({
  isVisible,
  isAlwaysVisible,
  children,
}: StickyBarProps) => {
  return ReactDOM.createPortal(
    <BottomStickyContainer
      $isVisible={isVisible}
      $isAlwaysVisible={isAlwaysVisible}
    >
      {children}
    </BottomStickyContainer>,
    document.body,
  );
};

export const TopStickyBar = ({
  isVisible,
  isAlwaysVisible,
  children,
}: StickyBarProps) => {
  return ReactDOM.createPortal(
    <TopStickyContainer
      $isVisible={isVisible}
      $isAlwaysVisible={isAlwaysVisible}
    >
      {children}
    </TopStickyContainer>,
    document.body,
  );
};
